<template>
  <div class="game-inner" ref="gameInner">
    <span class="game-close" @click="onClose">
      <svg-icon icon="close" />
    </span>
    <GamePlayer @onGamePlaySubmit="onClose" ref="gamePlayer" />
  </div>
</template>
<script>
import GamePlayer from '@/components/GamePlayer.vue'
/**
 * 高频互动，包含
 * 131 单选题
 * 132 拖拽题
 * 133 大显身手
 */
export default {
  components: {
    GamePlayer
  },
  props: {
    event: Object
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    console.log('event', this.event)
    const { params } = this.event
    this.$refs.gamePlayer.loadGame(params)
  },
  methods: {
    onClose() {
      this.$emit('realEnd')
    }
  }
}
</script>
<style lang="less" scoped>
.game-inner {
  position: absolute;
  margin: 0 auto;
  left: 60px;
  right: 60px;
  top: 0;
  bottom: 0;
  .game-close {
    position: absolute;
    color: #fff;
    right: -42px;
    top: 16px;
    display: flex;
    width: 30px;
    height: 30px;
    background: #FFFFFF;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    :deep(svg) {
      fill: #70788C;
      font-size: 13px;
    }
  }
}
</style>